export const FULL_DSA = 'full';
export const NEW_CUSTOMER_DSA = 'new-customer';




// WEBPACK FOOTER //
// ./src/constants/dsaTypes.js